import Fuse from 'fuse.js'
import { isEmpty } from 'lodash'
import { FUSE_OPTIONS } from 'utils/fuseSettings'

export const selectableListItems = (
  allItems,
  searchQuery,
  selectedFilterOption,
  // selectedItems is an array of uuids of items that are checked
  // usually values.items
  selectedItems,
  fuseSettings = FUSE_OPTIONS
) => {
  // filter items by search query
  const filteredItemsBySearchQuery = isEmpty(searchQuery)
    ? allItems
    : new Fuse(allItems, fuseSettings)
        .search(searchQuery)
        .map((item) => item?.item)

  // filter items by selected filter option
  // if selected filter option is 'all', then display all items
  // else, display only items that are selected
  const filteredItemsBySelectedFilterOption =
    selectedFilterOption === 'all'
      ? filteredItemsBySearchQuery
      : filteredItemsBySearchQuery?.filter((item) =>
          selectedItems?.includes(item?.uuid)
        )

  // it returns uuids of items that are checked and displayed on the list
  // for example, if there are 10 items checked, but only 6 items are displayed on the list
  // then it returns uuids of 4 items that are displayed on the list
  // not all 10 items that are checked
  const checkedItemsWithinFilteredItemsUuids =
    filteredItemsBySelectedFilterOption
      ?.filter((item) => selectedItems?.includes(item?.uuid))
      ?.map((item) => item?.uuid)

  // it returns uuids of items that are checked but not displayed on the list
  // for example, if there are 10 items checked, but only 6 items are displayed on the list
  // then it returns uuids of 4 items that are not displayed on the list
  // not all 10 items that are checked
  const itemsSelectedNotDisplayed = selectedItems?.filter(
    (item) => !checkedItemsWithinFilteredItemsUuids?.includes(item)
  )

  const isCheckAll =
    checkedItemsWithinFilteredItemsUuids?.length ===
      filteredItemsBySelectedFilterOption?.length &&
    checkedItemsWithinFilteredItemsUuids?.length > 0

  const isIndeterminate =
    checkedItemsWithinFilteredItemsUuids?.length <
      filteredItemsBySelectedFilterOption?.length &&
    checkedItemsWithinFilteredItemsUuids?.length > 0

  const isDisabled =
    filteredItemsBySelectedFilterOption?.length === 0 ?? false

  return {
    filteredItemsBySelectedFilterOption,
    checkedItemsWithinFilteredItemsUuids,
    itemsSelectedNotDisplayed,
    isCheckAll,
    isIndeterminate,
    isDisabled,
  }
}
